import { CocosConstants, HP_GLOBAL_RESOURCES } from './constants';
import { CocosServices } from './services';
import { MainSceneCocos } from './cocos/scripts/MainScene'
import { GameObjectManager } from './cocos/scripts/plan/GameObjectManager';
import { ActionStateEnum } from './cocos/scripts/state/actionState/ActionState'
import {  PlanManager } from './cocosPlan';
import { Coating, Commands, ComponentConstants, Entity, Events, eventsManager, JSONImporter, Listener, SceneConstants, Wall, World } from '@rhinov/savane-js';

declare var cc: any;

export class CocosController {

    parent: HTMLElement;
    rhinovFormat: World;
    rightPanel: boolean;
    planId: number;
    autoCache: boolean;
    user: any;
    modulePath: string;
    functionalities = [];
    CocosInitialized: boolean = false;

        //Create cocos container
    contextualEntity: Entity | null = null;
    contextualComponent: any = null;
    lastDeletedFloor: number | undefined;
    forceApply: boolean = false;
    floorGeneratorApplied: boolean = false;
    displayContextualMenuEvent: Listener | null;
    wallDirect: Wall | undefined;
    displayContextualMenuCoatingAreaEvent: Listener | null;
    replaceCoatingArea: CallableFunction | undefined;
    applyJointCoatingArea: CallableFunction | undefined;
    applyCleatCoatingArea: CallableFunction | undefined;
    initListener: Listener | null;
    projectDidLoadListener: Listener | null;
    closeModalListener: Listener | null;
    planFloorChangedListener: Listener | null;

    OpenFrontviewListener: Listener | null;

    deleteFloorListener: Listener | null;
    swapFloorListener: Listener | null;
    changeFloorListener: Listener | null;

    keyAttach: boolean= false;
    resizeTimeout: ReturnType<typeof setTimeout> | null = null;

    cameraResizedListener: Listener | null;
    fullscreenListener: Listener | null;
    displaySizeChanged: Listener | null;
    pauseListener: Listener | null;
    resumeListener: Listener | null;
    resizePlanFrame: Listener | null;
    updateFormatListener: Listener | null;
    addFloorListener: Listener | null;
    visumode: boolean = false;

    constructor(parent: HTMLElement, rhinovFormat: World, rightPanel: boolean, planId: number, autocache: boolean, user: any, modulepath: string) {
        this.parent = parent;
        this.rhinovFormat = rhinovFormat;
        this.rightPanel = rightPanel;
        this.planId = planId;
        this.autoCache = autocache;
        this.user = user;
        this.modulePath = modulepath;

        //Set constant path FIXME maybe find a better way to do that
        if (this.modulePath) {
            CocosConstants.resourcesBasePath = this.modulePath;
        }

        this.parent.addEventListener('contextmenu', (event) => {
            event.preventDefault();
            return false;
        });
        
        //Init HomePlanner resources
        HP_GLOBAL_RESOURCES.resourcesBasePath = CocosConstants.resourcesBasePath + '/resources/'
        HP_GLOBAL_RESOURCES.resources.list = [
            HP_GLOBAL_RESOURCES.resourcesBasePath + 'selectedDrop.png',
            HP_GLOBAL_RESOURCES.resourcesBasePath + 'chipBack.png',
            //Interfaces
            HP_GLOBAL_RESOURCES.resourcesBasePath + 'HPSpriteSheet.png',
            HP_GLOBAL_RESOURCES.resourcesBasePath + 'HPSpriteSheet.plist',
            //Fonts
            HP_GLOBAL_RESOURCES.resourcesBasePath + '/Roboto-Light.ttf'
        ];

        //Attributs
        var joint = document.getElementById('applyJoint');
        var jointWall = document.getElementById('applyJointWall');
        
        if (joint) {
            joint.classList.add('hide');
        }
        if (jointWall) {
            jointWall.classList.add('hide');
        }

        this.displayContextualMenuEvent = eventsManager.instance.addListener(Events.SHOW_CONTEXTUAL_MENU, (event: any) => {
            this.floorGeneratorApplied = false;
            var joint = document.getElementById('applyJoint');
            var jointWall = document.getElementById('applyJointWall');
            var i = 0;

            if (joint) {
                joint.classList.add('hide');
            }
            if (jointWall) {
                jointWall.classList.add('hide');
            }
            for (; i < event.userData.entity.components.length; ++i) {
                var component = event.userData.entity.components[i];
                if (component.componentType == ComponentConstants.ComponentType.Coating) {
                    if (component.floorGeneratorSettings) {
                        this.floorGeneratorApplied = true;
                        if (joint) {
                            joint.classList.remove('hide');
                        }
                        if (jointWall) {
                            jointWall.classList.remove('hide');
                        }
                        break;
                    }
                }
            }
            var dropdownMenu = document.getElementById('ContextualMenuRoom');

            if (event.userData.entity.isStaircaseEntity()) {
                dropdownMenu = document.getElementById('ContextualMenuStair');
            }

            if (event.userData.entity.isGeometryGroupEntity() || event.userData.entity.isGeometryPrimitiveEntity()) {
                dropdownMenu = document.getElementById('ContextualMenuGeoPrim');
            }

            if (event.userData.entity.isWallEntity()) {
                dropdownMenu = document.getElementById('ContextualMenuWall');
            }

            if (event.userData.entity.isGeometryGroupEntity() || event.userData.entity.isGeometryPrimitiveEntity()) {
                dropdownMenu = document.getElementById('ContextualMenuGeoPrim');
            }

            var dropdownContainer = document.getElementById('ContextualMenu');
            var x = PlanManager.getInstance().CanvasMouseX;
            var y = PlanManager.getInstance().CanvasMouseY;
            dropdownMenu!.style.display = 'block';
            dropdownContainer!.style.left = x.toString() + 'px';
            dropdownContainer!.style.top = y.toString() + 'px';

            this.contextualEntity = event.userData.entity;
            this.contextualComponent = event.userData.component;
            this.forceApply = event.userData.forceApply;
            this.wallDirect = event.userData.wallDirect;
        });

        this.displayContextualMenuCoatingAreaEvent = eventsManager.instance.addListener(Events.SHOW_CONTEXTUAL_MENU_COATING_AREA, (event: any) => {
            var dropdownMenu = document.getElementById('ContextualMenuCoatingArea');
            var dropdownContainer = document.getElementById('ContextualMenu');
            var joint = document.getElementById('applyJointCoatingArea');
            var cleat = document.getElementById('applyCleatCoatingArea');
            var x = PlanManager.getInstance().CanvasMouseX;
            var y = PlanManager.getInstance().CanvasMouseY;
            dropdownMenu!.style.display = 'block';
            dropdownContainer!.style.left = x.toString() + 'px';
            dropdownContainer!.style.top = y.toString() + 'px';
            if (joint) {
                joint.classList.add('hide');
            }
            if (cleat) {
                cleat.classList.add('hide');
            }

            this.replaceCoatingArea = event.userData.replaceCallback;
            this.applyJointCoatingArea = event.userData.jointCallback;
            if (joint && this.applyJointCoatingArea) {
                joint.classList.remove('hide');
            }
            this.applyCleatCoatingArea = event.userData.cleatCallback;
            if (cleat && this.applyCleatCoatingArea) {
                cleat.classList.remove('hide');
            }
        });

        // End of contextual drop downs

        var loadingImgPath = CocosConstants.resourcesBasePath + '/resources/cocosLoading.png';
        // if (attrs.loadingImgPath !== null && attrs.loadingImgPath !== undefined) {
        //     loadingImgPath = attrs.loadingImgPath;
        // }

        //Add loading to be displayed will cocos is loading
        if (!this.CocosInitialized) {
            setTimeout(() => {
                var height = this.parent.clientHeight;
                if (this.rightPanel) {
                    var rightPanel = document.getElementById("right-panel");
                    var planFilter = document.getElementById("planFiltersGroupsBar");
                    if (rightPanel) {
                        height = rightPanel.clientHeight;
                    }

                    if (planFilter) {
                        height -= planFilter.clientHeight;
                    }
                }
                this.parent.insertAdjacentHTML('afterbegin', '<div id="cocosLoading" class="cocos-loading-back" style="height:' + height + 'px"><img src="' + loadingImgPath + '" class="cocos-loading-pulse"/></div>');
            });
        }

        this.initListener = eventsManager.instance.addListener(Events.COCOS_MANUAL_INIT, this.initFn.bind(this));
        // this.projectLoadedListener = this.$on('project-loaded', function(res) {
        //     eventsManager.instance.dispatch(Events.DIRECTIVE_COCOS_INIT, {
        //         element: this.parent,
        //         current: true,
        //         customFormat: this.rhinovFormat
        //     });
        //     //this.loadRootProjectScene(this.parent,attrs.isCurrentProject);
        // });
        //Listen to cocos loading
        this.projectDidLoadListener = eventsManager.instance.addListener(Events.PROJECT_DID_LOAD, (_event: any) => {
            PlanManager.getInstance().autoCache = this.autoCache !== undefined ? this.autoCache : true;
            //Register global events
            var canvas = document.getElementById('gameCanvas');
            if (canvas) {
                canvas.addEventListener('mousemove', this.mouseMove);
                canvas.addEventListener('touchmove', this.touchMove);
                //Attach key listeners
                this.keyAttach = true;
                canvas.addEventListener('keydown', this.keyPressed);
                canvas.addEventListener('keyup', this.keyUnPressed);
            }
            var loading = document.getElementById('cocosLoading');
            if (loading) {
                loading.style.transition = 'opacity 600ms';
                loading.style.opacity = String(1);
                requestAnimationFrame(() => {
                    loading!.style.opacity = String(0);
                    setTimeout(() => {
                        loading!.remove()
                        this.resize();
                    }, 600);
                })
            }
            //Hide loading

            return Events.UNREGISTER;
        });
        //ModalClosed
        this.closeModalListener = eventsManager.instance.addListener(Events.CLOSE_MODAL, () => {
            //Register global events
            var canvas = document.getElementById('gameCanvas');
            if (canvas) {
                canvas.addEventListener('mousemove', this.mouseMove);
                canvas.addEventListener('touchmove', this.touchMove);
                //Attach key listeners
                this.keyAttach = true;
                canvas.addEventListener('keydown', this.keyPressed);
                canvas.addEventListener('keyup', this.keyUnPressed);
            }
            //Hide loading
            var loading = document.getElementById('cocosLoading');
            if (loading) {
                loading.style.transition = 'opacity 600ms';
                loading.style.opacity = String(1);
                requestAnimationFrame(() => {
                    loading!.style.opacity = String(0);
                    setTimeout(() => {
                        loading!.remove();
                        this.resize(true);
                    }, 600); 
                })
            }
        });
        //Listener to set edit mode
        //Remove the default behaviour goiing to edition
        this.planFloorChangedListener = eventsManager.instance.addListener(Events.PLAN_FLOOR_CHANGED, (_param: any) => {
            if (PlanManager.getInstance().world.name === 'importedPlan') {
                PlanManager.getInstance().world.name = '';
            }
            //PlanManager.getInstance().switchToEdition();
            return Events.UNREGISTER;
        });

        this.OpenFrontviewListener = eventsManager.instance.addListener(Events.OPEN_FRONT_VIEW, () => {
            var buttons = document.getElementById('frontViewButtons');
            if (buttons) {
                buttons.classList.remove('hide');
            }
        })

        this.deleteFloorListener = eventsManager.instance.addListener(Events.FLOOR_DELETE, this.deleteFloor.bind(this));
        this.swapFloorListener = eventsManager.instance.addListener(Events.FLOOR_SWAP, this.swapFloor.bind(this));
        this.changeFloorListener = eventsManager.instance.addListener(Events.FLOOR_CHANGE, this.changeFloor.bind(this));
        this.addFloorListener = eventsManager.instance.addListener(Events.FLOOR_ADD, this.addFloor.bind(this));

        this.keyAttach = false;
        this.resizeTimeout = null;

        window.onresize = () => this.resize();
        this.cameraResizedListener = eventsManager.instance.addListener(Events.CAMERA_RESIZED, () => {
            this.resize();
        });
        this.fullscreenListener = eventsManager.instance.addListener(Events.FULLSCREEN_CHANGED, () => {
            this.resize();
        });
        this.displaySizeChanged = eventsManager.instance.addListener('display_size_changed', () => {
            setTimeout(() => {
                this.resize();
            });
        });
        this.pauseListener = eventsManager.instance.addListener('cocos-plan-pause', () => {
            cc.game.pause();
        });
        this.resumeListener = eventsManager.instance.addListener('cocos-plan-resume', () => {
            cc.game.resume();
        });
        /**
         * Listener to catch event to update frame size without window based resize
         * FIXME It may be usefull to pass the dom elemnt as param to handle case where multiple RESIZE_PLAN_FRAME may be sent by different element
         */
        this.resizePlanFrame = eventsManager.instance.addListener(Events.RESIZE_PLAN_FRAME,
            this.resize
        );
        /**
         * Listener to catch event that update rhinov format datas
         */
        this.updateFormatListener = eventsManager.instance.addListener(Events.UPDATE_RHINOV_FORMAT, (event: any) => {
            var newValue = event.userData;
            var oldValue = this.rhinovFormat;

            this.rhinovFormat = event.userData;
            if (this.CocosInitialized && newValue !== oldValue) {
                this.restartScene();


            } else if (oldValue === null) {
                this.initFn();
            }
        });

        if (this.rhinovFormat !== undefined && this.rhinovFormat !== null) {
            this.initFn();
        }
    }

    snapEnabled() {
        if (!this.CocosInitialized) {
            return false;
        }

        return PlanManager.getInstance().snapEnabled;
    };

    toggleSnap() {
        PlanManager.getInstance().snapEnabled = !PlanManager.getInstance().snapEnabled;
        var icon = document.getElementById('notSnap');
        if (icon) {
            if (this.snapEnabled()) {
                icon.classList.add('hide');
            } else {
                icon.classList.remove('hide');
            }
        }
        eventsManager.instance.dispatch(Events.SNAP_UPDATED);
    };

    displaySnap() {
        if (!this.CocosInitialized || this.visumode) {
            return false;
        }
        return(PlanManager.getInstance().getAction() !== ActionStateEnum.SelectedOrderRoom && PlanManager.getInstance().getAction() !== ActionStateEnum.RoomsValidation);
    };

    toggleAngleSnap() {
        PlanManager.getInstance().magnetRotation = !PlanManager.getInstance().magnetRotation;
        var icon = document.getElementById('notSnapAngle');
        if (icon) {
            if (this.angleSnapEnabled()) {
                icon.classList.add('hide');
            } else {
                icon.classList.remove('hide');
            }
        }
        eventsManager.instance.dispatch(Events.ANGLE_SNAP_UPDATED);
    };

    displayAngleSnap() {
        if (!this.CocosInitialized || this.visumode) {
            return false;
        }
        return(PlanManager.getInstance().getAction() !== ActionStateEnum.SelectedOrderRoom  && PlanManager.getInstance().getAction() !== ActionStateEnum.RoomsValidation);
    };

    angleSnapEnabled() {
        if (!this.CocosInitialized) {
            return false;
        }

        return PlanManager.getInstance().magnetRotation;
    };

    isFrontView() {
        if (this.CocosInitialized == true) {
            return (PlanManager.getInstance().isFrontView());
        }
        return false;
    };

    toogleFrontViewDrawMode() {
        var button = document.getElementById('frontViewDrawMode');
        if (this.CocosInitialized == true) {
            PlanManager.getInstance().frontViewDrawMode = (PlanManager.getInstance().frontViewDrawMode + 1) % 2;
        }
        if (button) {
            if (PlanManager.getInstance().frontViewDrawMode === 0) {
                button.innerHTML = `
                    <span class="fa-stack">
                        <i class="fas fa-stack-1x fa-draw-polygon" style="line-height: 2em;"></i>
                    </span>
                `;
            } else {
                button.innerHTML = `
                    <span class="fa-stack">
                        <i class="far fa-stack-1x fa-square" style="line-height: 2em;"></i>
                    </span>
                `;
            }
        }
    }

    frontViewDrawMode() {
        if (this.CocosInitialized == true) {
            return PlanManager.getInstance().frontViewDrawMode;
        }
        return 0;
    };

    closeFrontView() {
        var buttons = document.getElementById('frontViewButtons');
        if (buttons) {
            buttons.classList.add('hide');
        }
        switch((PlanManager.getInstance()._state as any).state) {
            case ActionStateEnum.FrontView:
                PlanManager.getInstance()._state.keyPressed(cc.KEY.escape);
                break;

            case ActionStateEnum.FrontViewAddArea:
            case ActionStateEnum.FrontViewAddJoinery:
            case ActionStateEnum.FrontViewCutArea:
                // Go back to normal topview edition (construction or decoration)
                PlanManager.getInstance().switchToNormalMode(true);
                // If not construction (i.e. decoration), close webgl front view too
                
                eventsManager.instance.dispatch(Events.CLOSE_FRONT_VIEW, null);
                break;

            default:
                // Go back to normal topview edition (construction or decoration)
                PlanManager.getInstance().switchToNormalMode(false);
                // If not construction (i.e. decoration), close webgl front view too
                eventsManager.instance.dispatch(Events.CLOSE_FRONT_VIEW, null);
                break;
        }
    };

    swapFrontView() {
        PlanManager.getInstance()._state.keyPressed(33);
    };

    applyStep() {
        // Create a change coating comman with the entity to paint, the coating and the apply mode
        var changeCoatingCommand = new Commands.ChangeCoatingCommand(this.contextualEntity!, this.contextualComponent, Coating.HangType.usemtl, '1');
        // Execute the command
        PlanManager.getInstance().executeCommand(changeCoatingCommand);

        var menu = document.getElementById('ContextualMenuStair');
        if (menu) {
            menu.style.display = 'none';
        }
    };

    applyCounterStep() {
        // Create a change coating comman with the entity to paint, the coating and the apply mode
        var changeCoatingCommand = new Commands.ChangeCoatingCommand(this.contextualEntity!, this.contextualComponent, Coating.HangType.usemtl, '2');
        // Execute the command
        PlanManager.getInstance().executeCommand(changeCoatingCommand);

        var menu = document.getElementById('ContextualMenuStair');
        if (menu) {
            menu.style.display = 'none';
        }

    };

    applyLimon() {
        // Create a change coating comman with the entity to paint, the coating and the apply mode
        var changeCoatingCommand = new Commands.ChangeCoatingCommand(this.contextualEntity!, this.contextualComponent, Coating.HangType.usemtl, '3');
        // Execute the command
        PlanManager.getInstance().executeCommand(changeCoatingCommand);

        var menu = document.getElementById('ContextualMenuStair');
        if (menu) {
            menu.style.display = 'none';
        }
    };

    applyStairBack() {
        // Create a change coating comman with the entity to paint, the coating and the apply mode
        var changeCoatingCommand = new Commands.ChangeCoatingCommand(this.contextualEntity!, this.contextualComponent, Coating.HangType.usemtl, '5');
        // Execute the command
        PlanManager.getInstance().executeCommand(changeCoatingCommand);

        var menu = document.getElementById('ContextualMenuStair');
        if (menu) {
            menu.style.display = 'none';
        }
    };

    applyAllStair() {
        PlanManager.getInstance().executeCommand(new Commands.ChangeCoatingCommand(this.contextualEntity!, this.contextualComponent, Coating.HangType.usemtl, '1'));
        PlanManager.getInstance().executeCommand(new Commands.ChangeCoatingCommand(this.contextualEntity!, this.contextualComponent, Coating.HangType.usemtl, '2'));
        if (!this.contextualComponent.isHpFloorGenerator) {
            PlanManager.getInstance().executeCommand(new Commands.ChangeCoatingCommand(this.contextualEntity!, this.contextualComponent, Coating.HangType.usemtl, '3'));
            PlanManager.getInstance().executeCommand(new Commands.ChangeCoatingCommand(this.contextualEntity!, this.contextualComponent, Coating.HangType.usemtl, '5'));
        }
        var menu = document.getElementById('ContextualMenuStair');
        if (menu) {
            menu.style.display = 'none';
        }
    };

    applyFloor() {
        if (!this.contextualComponent.hang.floor && !this.forceApply) {
            eventsManager.instance.dispatch(Events.DISPLAY_ALERT, { message: 'Ce matériau ne peut pas être appliqué sur cette surface' });
        }
        else {
            // Create a change coating comman with the entity to paint, the coating and the apply mode
            var changeCoatingCommand = new Commands.ChangeCoatingCommand(this.contextualEntity!, this.contextualComponent, Coating.HangType.floor, undefined as unknown as string);
            // Execute the command
            PlanManager.getInstance().executeCommand(changeCoatingCommand);
        }

        var menu = document.getElementById('ContextualMenuRoom');
        if (menu) {
            menu.style.display = 'none';
        }
    };

    applyJoint() {
        for (var i = 0; i < this.contextualEntity!.components.length; ++i) {
            var component = this.contextualEntity!.components[i] as Coating;
            if (component.componentType == ComponentConstants.ComponentType.Coating) {
                if (component.floorGeneratorSettings && component.hangType === Coating.HangType.floor) {
                    if (this.contextualComponent.isHpFloorGenerator) {
                        eventsManager.instance.dispatch(Events.DISPLAY_ALERT, { message: 'Les matériaux FloorGenerator sont interdits sur les joints.' });
                    } else {
                        component.floorGeneratorSettings.jointCoating = {
                            id: this.contextualComponent._id,
                            colors: (this.contextualComponent.colors !== undefined ? [this.contextualComponent.colors] : this.contextualComponent.configs)
                        }
                    }
                    break;
                }
            }
        }

        PlanManager.getInstance().saveInCache();
        eventsManager.instance.dispatch(Events.FLOOR_GENERATOR_CHANGED);
        var menu = document.getElementById('ContextualMenuRoom');
        if (menu) {
            menu.style.display = 'none';
        }
    };

    applyCeiling() {
        if (!this.contextualComponent.hang.ceiling && !this.forceApply) {
            eventsManager.instance.dispatch(Events.DISPLAY_ALERT, { message: 'Ce matériau ne peut pas être appliqué sur cette surface' });
        }
        else {
            // Create a change coating comman with the entity to paint, the coating and the apply mode
            var changeCoatingCommand = new Commands.ChangeCoatingCommand(this.contextualEntity!, this.contextualComponent, Coating.HangType.ceiling, undefined as unknown as string);
            // Execute the command
            PlanManager.getInstance().executeCommand(changeCoatingCommand);
        }

        var menu = document.getElementById('ContextualMenuRoom');
        if (menu) {
            menu.style.display = 'none';
        }
    };

    applyWall() {
        if (!this.contextualComponent.hang.wall && !this.forceApply) {
            eventsManager.instance.dispatch(Events.DISPLAY_ALERT, { message: 'Ce matériau ne peut pas être appliqué sur cette surface' });
        }
        else {
            // Create a change coating comman with the entity to paint, the coating and the apply mode
            var hangType = (this.wallDirect ? Coating.HangType.wallDirect : Coating.HangType.wallUndirect);
            var changeCoatingCommand = new Commands.ChangeCoatingCommand(this.contextualEntity!, this.contextualComponent, hangType, undefined as unknown as string);
            // Execute the command
            PlanManager.getInstance().executeCommand(changeCoatingCommand);
        }

        var menu = document.getElementById('ContextualMenuWall');
        if (menu) {
            menu.style.display = 'none';
        }
    };

    applyJointWall() {
        var hangType = (this.wallDirect ? Coating.HangType.wallDirect : Coating.HangType.wallUndirect);
        var component: any = null;
        for (var i = 0; i < this.contextualEntity!.components.length; ++i) {
            component = this.contextualEntity!.components[i] as Coating;
            if (component.componentType == ComponentConstants.ComponentType.Coating) {
                if ((component as Coating).floorGeneratorSettings && (component as Coating).hangType === hangType) {
                    if (this.contextualComponent.isHpFloorGenerator) {
                        eventsManager.instance.dispatch(Events.DISPLAY_ALERT, { message: 'Les matériaux FloorGenerator sont interdits sur les joints.' });
                    } else {
                        (component as Coating).floorGeneratorSettings.jointCoating = {
                            id: this.contextualComponent._id,
                            colors: (this.contextualComponent.colors !== undefined ? [this.contextualComponent.colors] : this.contextualComponent.configs)
                        }
                    }
                    break;
                }
            }
        }

        PlanManager.getInstance().saveInCache();
        if (component) {
            eventsManager.instance.dispatch(Events.COMMAND_EXECUTED, {
                name: Commands.CommandEnum.ChangeCoatingCommand,
                undo: false,
                datas: {entity: this.contextualEntity, component: component}
            });
        }
        var menu = document.getElementById('ContextualMenuRoom');
        if (menu) {
            menu.style.display = 'none';
        }
    };

    applyGeoPrim() {
        // Create a change coating command with the entity to paint, the coating and the apply mode
        var hangType = Coating.HangType.technicalElement;
        var changeCoatingCommand = new Commands.ChangeCoatingCommand(this.contextualEntity!, this.contextualComponent, hangType, undefined as unknown as string);
        // Execute the command
        PlanManager.getInstance().executeCommand(changeCoatingCommand);

        var menu = document.getElementById('ContextualMenuGeoPrim');
        if (menu) {
            menu.style.display = 'none';
        }
    };

    applyJointGeoPrim() {
        var component: any = null;
        for (var i = 0; i < this.contextualEntity!.components.length; ++i) {
            component = this.contextualEntity!.components[i] as Coating;
            if (component.componentType == ComponentConstants.ComponentType.Coating) {
                if ((component as Coating).floorGeneratorSettings) {
                    if (this.contextualComponent.isHpFloorGenerator) {
                        eventsManager.instance.dispatch(Events.DISPLAY_ALERT, { message: 'Les matériaux FloorGenerator sont interdits sur les joints.' });
                    } else {
                        (component as Coating).floorGeneratorSettings.jointCoating = {
                            id: this.contextualComponent._id,
                            colors: (this.contextualComponent.colors !== undefined ? [this.contextualComponent.colors] : this.contextualComponent.configs)
                        }
                    }
                    break;
                }
            }
        }

        PlanManager.getInstance().saveInCache();
        if (component) {
            eventsManager.instance.dispatch(Events.COMMAND_EXECUTED, {
                name: Commands.CommandEnum.ChangeCoatingCommand,
                undo: false,
                datas: {entity: this.contextualEntity, component: component}
            });
        }
        var menu = document.getElementById('ContextualMenuGeoPrim');
        if (menu) {
            menu.style.display = 'none';
        }
    };
    
    //EXPOSER
    initFn() {
        //Retrieve functionalities to handle rooms in cocos
        CocosServices.getAllFunctionality((response: any) => {
            this.functionalities = response !== null ? response.data : [];
            this.loadScene(this.rhinovFormat, this.functionalities);
        });
        eventsManager.instance.removeListener(this.initListener!);
    };
    
    /**
     * Remove a floor
     * @param floorId
     */
    deleteFloor(datas: any) {
        var floorId = datas.getUserData();
        cc.director._runningScene.deleteFloor(floorId);
        this.lastDeletedFloor = floorId;
    };
    /**
     * Swap 2 floors
     * @param floorA
     * @param floorB
     */
    swapFloor(datas: any) {
        // The two floors to swap
        var floorA = datas.getUserData().floorA;
        var floorB = datas.getUserData().floorB;
        // Determine the upper and the lower floors
        var upperFloor;
        var lowerFloor;

        if (floorA.height > floorB.height) {
            upperFloor = floorA;
            lowerFloor = floorB;
        }
        else {
            upperFloor = floorB;
            lowerFloor = floorA;
        }

        // Special case of the ground floor being moved down (we always want the ground floor to be 0 height)
        if (upperFloor.height === 0) {
            var swap = lowerFloor.height;

            lowerFloor.height = 0;
            upperFloor.height = swap;

            // Let plan manager recompute all floor heights above the new ground floor
            lowerFloor.readjustFloorsHeight();
            // Let plan manager recompute all floor heights underneath the new ground floor (this will update the floor just underneath too)
            upperFloor.readjustFloorsHeight();
        }
        else {
            // Put the upper floor at the bottom floor height
            upperFloor.height = lowerFloor.height;
            // Get new the lowerFloor height (it was upperFloor)
            var floorHeight = upperFloor.getFloorMaxRoomHeight()
            if (floorHeight === 0) {
                floorHeight = SceneConstants.DefaultWallHeight;
            }
            // And place the new upper floor height correctly
            lowerFloor.height = upperFloor.height + (floorHeight + SceneConstants.DefaultInterfloorHeight);
        }

        cc.director._runningScene.setFloor(floorA.id);
    };
    /**
     * Change current floor
     * @param floorId
     */
    changeFloor(datas: any) {
        var floorId = datas.getUserData();
        if (floorId != this.lastDeletedFloor) {
            cc.director._runningScene.setFloor(floorId);
        } else {
            cc.director._runningScene.setFloor();
            this.lastDeletedFloor = -1;
        }
    }

    /**
     * Add floor
     * @param isUp
     */
    addFloor(datas: any) {
        var isUp = datas.getUserData();
        var floorConfig = {
            'papersketch': (document.getElementById('exportPaperSketch') as HTMLInputElement).checked,
            'alltherest': (document.getElementById('exportAllTheRest') as HTMLInputElement).checked,
            'walls': (document.getElementById('exportWalls') as HTMLInputElement).checked,
            'joineries': (document.getElementById('exportJoineries') as HTMLInputElement).checked,
            'isUp': isUp
        };
        cc.director._runningScene.addFloor(floorConfig);
        setTimeout(function() {
            var button = document.getElementById('floorButton');
            if (button) {
                button.click();
            }
        }, 50);
    };
    /**
     * Mouse move storing datas
     * @param event
     */
    mouseMove(event: any) {
        var gameCanvas = document.getElementById('gameCanvas');
        var rec = gameCanvas!.getBoundingClientRect();
        PlanManager.getInstance().CanvasMouseX = event.pageX - rec.left;
        PlanManager.getInstance().CanvasMouseY = event.pageY - rec.top;
    };
    touchMove(event: any) {
        var gameCanvas = document.getElementById('gameCanvas');
        var rec = gameCanvas!.getBoundingClientRect();
        var touch = event.originalEvent ? event.originalEvent.touches[0] : event.touches[0];
        PlanManager.getInstance().CanvasMouseX = touch.pageX - rec.left;
        PlanManager.getInstance().CanvasMouseY = touch.pageY - rec.top;
    };
    /**
     * Key handling
     *
     */
    keyPressed(e: any) {
        var evtObj = e;

        // Anti rebond sur toutes les touches alphabéthiques unless m
        if (evtObj.keyCode >= cc.KEY.a && evtObj.keyCode <= cc.KEY.z && evtObj.keyCode != cc.KEY.m && evtObj.repeat) {
            return;
        }

        if (evtObj.keyCode === cc.KEY.f11) {
            eventsManager.instance.dispatch(Events.FULLSCREEN_ASKED);
        }

        if (evtObj.keyCode === 188) {
            let url = 'https://sites.google.com/rhinov.fr/formation-rhinov/outils/home-planner-d%C3%A9coration?authuser=0'
            if (!PlanManager.getInstance()._state.isDecorationState()) {
                url = 'https://sites.google.com/rhinov.fr/formation-rhinov/outils/home-planner-plan?authuser=0';
            }
            window.open(url, "Aide HomePlanner", 'height=' + screen.height + ',width=' + screen.width + ',resizable=yes,scrollbars=yes,toolbar=yes,menubar=yes,location=yes');
        }
        if (evtObj.keyCode === cc.KEY.z && (evtObj.ctrlKey || e.metaKey) && !evtObj.shiftKey) {
            PlanManager.getInstance().undoCommand();
        } else if ((evtObj.keyCode === cc.KEY.z && evtObj.shiftKey && (evtObj.ctrlKey || e.metaKey)) || (evtObj.keyCode === cc.KEY.y && evtObj.ctrlKey && !evtObj.shiftKey)) {
            PlanManager.getInstance().redoCommand();
        } else if (evtObj.keyCode === cc.KEY.a && (evtObj.ctrlKey || e.metaKey)) {
            PlanManager.getInstance().selectAll();
        } else if (evtObj.keyCode === cc.KEY.s && (evtObj.ctrlKey || e.metaKey)) {
            eventsManager.instance.dispatch(Events.SAVE_SCENE);
        } else {
            PlanManager.getInstance().keyPressed(evtObj.keyCode, (evtObj.ctrlKey || e.metaKey));
        }
    };
    keyUnPressed(e: any) {
        var evtObj = e;
        PlanManager.getInstance().keyUnPressed(evtObj.keyCode);
    };
    /**
     *  Load scene and start cocos
     */
    loadScene(rhinovFormat: any, functionalities: any) {
        if (!rhinovFormat) {
            return;
        }

        var width = this.parent.clientWidth;
        var height = this.parent.clientHeight;

        cc.game.onStart = () => {
            // make sure FPS display is in screen
            cc.DIRECTOR_STATS_POSITION = cc.p(0, 50);
            cc._loaderImage = CocosConstants.resourcesBasePath + '/resources/loader.png';

            // Adjust viewport metas
            cc.view.adjustViewPort(true);

            cc.view.resizeWithBrowserSize(true);

            if (typeof MainSceneCocos === 'undefined') {
                console.log('MainSceneCocos undefined');
                return;
            }
            var BaseScene = new MainSceneCocos(width, height);
            cc.LoaderScene.preload(
                HP_GLOBAL_RESOURCES.resources.list, () => {
                    var tr = new cc.TransitionFade(0.5, BaseScene, new cc.color(0, 0, 0));
                    cc.director.runScene(tr);
                    BaseScene.setRhinovFormat(rhinovFormat, this.planId);
                    PlanManager.getInstance().scrollWindow.setScheduler(cc.director._scheduler);
                    PlanManager.getInstance().scrollWindow.scheduleUpdate();
                    //Delay to allow page to load
                    this.CocosInitialized = true;
                    let snap = document.getElementById('snap');
                    let notSnap = document.getElementById('notSnap');
                    let notSnapAngle = document.getElementById('notSnapAngle');
                    let snapAngle = document.getElementById('snapAngle');
                    if (snap && snapAngle) {
                        snap.classList[!this.displaySnap() ? "add" : "remove"]('hide');
                        snapAngle.classList[!this.displayAngleSnap() ? "add" : "remove"]('hide');
                    }
                    
                    if (notSnap) {
                        notSnap.classList[this.snapEnabled() ? "add" : "remove"]('hide');
                    }
                    if (notSnapAngle) {
                        notSnapAngle.classList[this.angleSnapEnabled() ? "add" : "remove"]('hide');
                    }
                    
                    eventsManager.instance.dispatch(Events.COCOS_INITIALIZED, BaseScene);
                    PlanManager.getInstance().scrollWindow.resize(width, height);
                    PlanManager.getInstance().frontViewLayer.setContentSize(width, height);
                    PlanManager.getInstance().user = this.user;

                    cc.view.setFrameSize(width, height);
                    cc.view.setDesignResolutionSize(width, height, cc.ResolutionPolicy.EXACT_FIT);
                }, this);

            if (functionalities === null)
                return;
            for (var i = 0; i < functionalities.length; ++i) {
                (GameObjectManager.roomFunctionalitiesData as Record<string, any>)[functionalities[i].id] = functionalities[i];
            }

            return true;
        };

        /**WARNING DO NOT TOUCH - This reset the cocos engine state !!!! */
        cc.Director.sharedDirector = null;
        cc.Director.firstUseDirector = true;
        cc.EGLView._instance = null;
        cc.loaderScene = null;
        cc.game._prepared = false;
        cc.game._rendererInitialized = false;
        cc.game._renderContext = null;
        cc.game._prepareCalled = false;
        cc.loader._jsCache = {}; // remove js cache
        cc.inputManager._isRegisterEvent = false;
        cc.game.run({
            "project_type": "javascript",
            "debugMode": cc.game.DEBUG_MODE_NONE,
            "showFPS": false,
            "frameRate": 60,
            "id": "gameCanvas",
            "renderMode": cc.game.RENDER_TYPE_WEBGL,
            "height": height,
            "width": width
        });
    };

    /**
     * Reload scene
     */
    restartScene() {
        PlanManager.getInstance().unloadCurrentFloor();
        PlanManager.getInstance().unloadUnderFloor();
        var json = this.rhinovFormat;
        PlanManager.getInstance().world = JSONImporter.importWorld(json);
        PlanManager.getInstance().loadWorld(PlanManager.getInstance().world);
    };

    resize(recenter?: boolean) {
        if (!this.CocosInitialized) {
            return;
        }

        cc.game.pause();
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }

        var width = this.parent.clientWidth;
        var height = this.parent.clientHeight;

        var gameCanvas = document.getElementById('gameCanvas');
        var superGame = document.getElementById('superGame');
        var Cocos2dGameContainer = document.getElementById('Cocos2dGameContainer');

        if (superGame) {
            superGame.style.height = height + "px";
            superGame.style.width = width + "px";
        }
        if (Cocos2dGameContainer) {
            Cocos2dGameContainer.style.height = height + "px";
            Cocos2dGameContainer.style.width = width + "px";
        }

        if (gameCanvas) {
        
            gameCanvas.style.height = height + "px";
            gameCanvas.style.width = width + "px";
            gameCanvas.setAttribute('height', height.toString());
            gameCanvas.setAttribute('width', width.toString());
        }

        if (!this.rightPanel) {
            var parent = this.parent.parentElement;
            if (parent && parent.getAttribute('id') == "tab-content") {
                parent.style.height = "";
                parent.style.bottom = "0px";
                var value;
                var ressource = document.querySelector('.resourcesContainer')
                if (ressource) {
                    value = ressource.clientHeight;
                }
                parent.style.top = value + "px";

                height = parent.clientHeight;
                var rightPanel = document.getElementById('right-panel');
                if (rightPanel) {
                    rightPanel.style.height = "";
                }
                if (superGame) {
                    superGame.style.height = height + "px";
                }
                if (Cocos2dGameContainer) {
                    Cocos2dGameContainer.style.height = height + "px";
                }
                if (gameCanvas) {
                    gameCanvas.style.height = height + "px";
                    gameCanvas.setAttribute('height', height.toString());
                }
                this.parent.style.height = height + "px";
                let right = document.querySelector('.quinta-right') as HTMLElement;
                if (right) {
                    right.style.top = value + "px";
                }

            }
        } else {
            var rightPanel = document.getElementById("right-panel");
            var planFilter = document.getElementById("planFiltersGroupsBar");
            if (rightPanel) {
                height = rightPanel.clientHeight;
            }

            if (planFilter) {
                height -= planFilter.clientHeight;
            }
            this.parent.style.height = height + "px";
        }

        if (cc.director._runningScene.setResolution) {
            cc.director._runningScene.setResolution(width, height);
        }
        PlanManager.getInstance().scrollWindow.resize(width, height);
        if (recenter) {
            PlanManager.getInstance().scrollWindow.centerPosition();
        }

        cc.view.setFrameSize(width, height);
        cc.view.setDesignResolutionSize(width, height, cc.ResolutionPolicy.EXACT_FIT);
        this.resizeTimeout = setTimeout(function() {
            cc.game.resume();
        }, 200);
    };

    //Destroy
    destroy() {
        //Destroy cocos scene
        if (cc.director._runningScene) {
            cc.director._runningScene.onStop();
        }
        cc.director.end();
        // if (this.changeDivList) {
        //     eventsManager.instance.removeListener(this.changeDivList);
        // }
        eventsManager.instance.removeListener(this.projectDidLoadListener!);
        eventsManager.instance.removeListener(this.closeModalListener!);
        eventsManager.instance.removeListener(this.resizePlanFrame!);
        eventsManager.instance.removeListener(this.deleteFloorListener!);
        eventsManager.instance.removeListener(this.swapFloorListener!);
        eventsManager.instance.removeListener(this.changeFloorListener!);
        eventsManager.instance.removeListener(this.addFloorListener!);
        eventsManager.instance.removeListener(this.updateFormatListener!);
        eventsManager.instance.removeListener(this.planFloorChangedListener!);
        eventsManager.instance.removeListener(this.fullscreenListener!);
        eventsManager.instance.removeListener(this.cameraResizedListener!);
        eventsManager.instance.removeListener(this.displaySizeChanged!);
        eventsManager.instance.removeListener(this.displayContextualMenuEvent!);
        eventsManager.instance.removeListener(this.displayContextualMenuCoatingAreaEvent!);
        eventsManager.instance.removeListener(this.pauseListener!);
        eventsManager.instance.removeListener(this.resumeListener!);
        //Remove global liteners
        var canvas = document.getElementById('gameCanvas');
        if (canvas) {
            canvas.removeEventListener('mousemove', this.mouseMove);
            canvas.removeEventListener('touchmove', this.touchMove);
            if (this.keyAttach) {
                canvas.removeEventListener('keydown', this.keyPressed);
                canvas.removeEventListener('keyup', this.keyUnPressed);
            }
        }
        window.onresize = null;
    };
}